export default {
  components: {
    notificationBadge: 'dt.notifications.components.notificationBadge',
  },
};
